/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"
import moment from "moment-timezone";

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
var mailtplRef;
if (ls.getSessionValueByKey("Role") == 1) {
    mailtplRef = con.instanceDB.doc('mailtpl');
} else {
    var mailtplRef = con.eventDB.collection(cn).doc('mailtpl');
}
const mailtplRefInstnc = con.instanceDB.doc('mailtpl');
const storageRef = con.storageRef;
let MailactivityApi = con.MailactivityApi
let MailactivityApiKey = con.MailactivityApiKey
let GetsubcollectionsApi = con.GetsubcollectionsApi

var Session_Event_FullName = ls.getSessionValueByKey("Session_Event_FullName");
var Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");

export default {
    fetchMailtplsOLD({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = [{
                    CollectionName: "ReminderMail",
                    DocName: "Reminder"
                },
                {
                    CollectionName: "welcomeMail",
                    DocName: "UserSignup"
                },
                {
                    CollectionName: "EventAdmin",
                    DocName: "WelcomeMail"
                },
                {
                    CollectionName: "forgotPass",
                    DocName: "forgotPass"
                },
                {
                    CollectionName: "AnnouncementMail",
                    DocName: "Announcement"
                }
            ];

            commit('SET_MAILTPLS', markers)
            resolve(markers)

            /*const markers = [] 
            mailtplRef.get().then(querySnapshot => {  
              querySnapshot.docs.forEach(doc => {              
                markers.push()           
              })  
              commit('SET_MAILTPLS', markers)
              resolve(markers)          
            }).catch(function (error) {
              //console.log('Error getting attendee:', error)
              reject(error)
            })*/

        })
    },
    fetchMailtpls({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = [];
            var path = "/" + (cn ? cn : "OA_UAT") + "/mailtpl";
            var requestData = {
                path: path
            };
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
            const headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
                //"apikey": MailactivityApiKey
            }
            axios.post(GetsubcollectionsApi, requestData, { headers: headers }).then((response) => {
                let collectionTotal = response.data.length
                let count = 0
                let EventAccessMsils = ['Speaker','welcomeMail','ReminderMail','AnnouncementMail'];
                if(response.data.length){
                    response.data.forEach(element => {
                        mailtplRef.collection(element).get().then(function(querySnapshot){
                            if(querySnapshot.docs.length){
                                querySnapshot.docs.forEach(doc => {
                                    if(cn && EventAccessMsils.includes(element) && Sesion_EventAccessType == 'Use Common Event Passcode'){
                                        if(doc.id.includes('EventAccess')){
                                            markers.push({
                                                CollectionName: element,
                                                DocName: doc.id,
                                                DisplayLabel: `${element} - ${doc.id}`
                                            })
                                        }
                                    }
                                    else
                                    {
                                        if(!doc.id.includes('EventAccess')){
                                            markers.push({
                                                CollectionName: element,
                                                DocName: doc.id,
                                                DisplayLabel: `${element} - ${doc.id}`
                                            })
                                        }
                                    }
                                })
                                count = count + 1   
                                if(count == collectionTotal)
                                {
                                    commit('SET_MAILTPLS', markers)
                                    resolve(markers)
                                }                             
                            }
                            else
                            {
                                count = count + 1   
                                if(count == collectionTotal)
                                {
                                    commit('SET_MAILTPLS', markers)
                                    resolve(markers)
                                }
                            }                          
                             
                        })
                    })
                }
                else
                {
                    commit('SET_MAILTPLS', markers)
                    resolve(markers)
                }
                
            })
        })
    },
    fetchGeneralSettings(context){
        return new Promise((resolve, reject) => {
            con.instanceDB.doc('GeneralSettings').get().then(function(doc){
                resolve(doc.data())
            })
        })
    },
    fetchdeliveryReport(context, field){
        return new Promise((resolve, reject) => {
            context.dispatch('fetchMailtpl', field).then(function(mailtplData){
                let accessToken = ls.getSessionValueByKey("Session_AccessToken");
                const headers = {
                    "apikey": MailactivityApiKey,
                    'Authorization': `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                }
                let requestData = {
                    "data": {
                      "subject": field.Subject ? field.Subject : mailtplData.data.subject,
                      "startdate": "",
                      "enddate": ""
                    }
                }
                axios.post(MailactivityApi, requestData, { headers: headers }).then((response) => {
                    resolve(response)
                })

            })
        })
    },
    fetchMailtpl(context, field) {
        return new Promise((resolve, reject) => {
            if (field.DocName && field.CollectionName) {
                let docObj = new Object();
                docObj.html = '';
                docObj.htmlRaw = '';
                docObj.designJson = null,
                docObj.subject = '';
                docObj.from = '';
                docObj.fromName = Session_Event_FullName;
                docObj.to = '';
                docObj.cc = '';
                docObj.bcc = '';
                docObj.TemplateName = field.CollectionName;
                docObj.Status = true;
                mailtplRefInstnc.collection(`${field.CollectionName}`).doc(`${field.DocName}`).get().then(function(doc) {
                    if (doc.exists) {
                        docObj.html = doc.data().html ? doc.data().html : '';
                        docObj.htmlRaw = doc.data().htmlRaw ? doc.data().htmlRaw : '';
                        docObj.designJson = doc.data().designJson ? doc.data().designJson : null,
                        docObj.subject = doc.data().subject ? doc.data().subject : '';
                        docObj.from = doc.data().from ? doc.data().from : '';
                        docObj.fromName = doc.data().fromName ? doc.data().fromName : Session_Event_FullName;
                        docObj.to = doc.data().to ? doc.data().to : '';
                        docObj.cc = doc.data().cc ? doc.data().cc : '';
                        docObj.bcc = doc.data().bcc ? doc.data().bcc : '';
                        docObj.TemplateName = doc.data().TemplateName ? doc.data().TemplateName : field.DocName;
                        docObj.Status = doc.data().Status != undefined ? doc.data().Status : true;
                    }

                    mailtplRef.collection(`${field.CollectionName}`).doc(`${field.DocName}`).get().then(function(doce) {
                        if (doce.exists) {
                            docObj.html = doce.data().html ? doce.data().html : '';
                            docObj.htmlRaw = doce.data().htmlRaw ? doce.data().htmlRaw : '';
                            docObj.designJson = doce.data().designJson ? doce.data().designJson : docObj.designJson;
                            docObj.subject = doce.data().subject ? doce.data().subject : docObj.subject
                            docObj.from = doce.data().from ? doce.data().from : docObj.from
                            docObj.fromName = doce.data().fromName ? doce.data().fromName : docObj.fromName
                            docObj.to = doce.data().to ? doce.data().to : docObj.to
                            docObj.cc = doce.data().cc ? doce.data().cc : docObj.cc
                            docObj.bcc = doce.data().bcc ? doce.data().bcc : docObj.bcc
                            docObj.TemplateName = doce.data().TemplateName ? doce.data().TemplateName : field.DocName;
                            docObj.Status = doce.data().Status != undefined ? doce.data().Status : true;                            
                        }
                        if (doc.exists || doce.exists)
                            resolve({ status: 200, data: docObj });
                        else
                            resolve({ status: 500, data: null });
                    })
                })

            } else {
                resolve({
                    status: 200,
                    data: {
                        html: '',
                        htmlRaw: '',
                        designJson: null,
                        subject: '',
                        from: '',
                        fromName: Session_Event_FullName,
                        to: '',
                        cc: '',
                        bcc: '',
                        TemplateName: null,
                        CreatedBy: '',
                        Status: true,
                        LastModifiedDate: new Date()
                    }
                });
            }

        })
    },
    fetchShortCodes(context) {
        return new Promise((resolve, reject) => {
            mailtplRefInstnc.collection('ShortCodes').doc('Codes').get().then(function(doc) {
                if (doc.exists) {
                    resolve({ status: 200, data: doc.data().ShortCodes })
                } else {
                    reject(error)
                }

            })
        })
    },
    updateShortCode(context, field) {
        return new Promise((resolve, reject) => {
            mailtplRefInstnc.collection('ShortCodes').doc('Codes').get().then(function(doc) {
                if (doc.exists) {
                    mailtplRefInstnc.collection('ShortCodes').doc('Codes').update({
                        ShortCodes: firebase.firestore.FieldValue.arrayUnion(field.data)
                    }).then(function(doc) {
                        resolve({ status: 200, message: 'Data Updated.' })
                    })

                } else {
                    mailtplRefInstnc.collection('ShortCodes').doc('Codes').set({
                        ShortCodes: [field.data]
                    }).then(function(doc) {
                        resolve({ status: 200, message: 'Data Added.' })
                    })
                }

            })
        })
    },
    updateMailtpl(context, field) {
        return new Promise((resolve, reject) => {
            var customDomain = ls.getSessionValueByKey("CustomDomain");
            if (customDomain !== null) {
                customDomain = 'https://' + ls.getSessionValueByKey("CustomDomain");
            } else {
                customDomain = '';
            }

            debugger;
            var eventStartDate = ls.getSessionValueByKey("Session_EventStartDate");
            var eventEndDate = ls.getSessionValueByKey("Session_EventEndDate");
            var timeZone = ls.getSessionValueByKey("Session_Event_TZ");

            var startDateTZ = moment(eventStartDate).format("MMM DD, YYYY");
            var startTimeTZ = moment(eventStartDate).format("hh:mm A");
            var startEndTZ = moment(eventEndDate).format("MMM DD, YYYY");
            var endTimeTZ = moment(eventEndDate).format("hh:mm A");

            var bodyHtml = field.data.html == undefined ? "" : field.data.html;
            bodyHtml = bodyHtml.replace("{{StartDate}}", startDateTZ);
            bodyHtml = bodyHtml.replace("{{StartTime}}", startTimeTZ);
            bodyHtml = bodyHtml.replace("{{EndDate}}", startEndTZ);
            bodyHtml = bodyHtml.replace("{{EndTime}}", endTimeTZ);
            bodyHtml = bodyHtml.replace("{{TimeZone}}", timeZone);
            bodyHtml = bodyHtml.replace('{{CustomDomain}}', customDomain);
            bodyHtml = bodyHtml.replace('{{CustomDomain}}', customDomain);

            mailtplRef.collection(`${field.CollectionName}`).doc(`${field.DocName}`).get().then(function(doc) {
                if (doc.exists) {
                    mailtplRef.collection(`${field.CollectionName}`).doc(`${field.DocName}`).update({
                            //html: (ls.getSessionValueByKey("Role") == 1) ? field.data.html : bodyHtml,
                            html: field.data.html,
                            htmlRaw: field.data.html,
                            designJson: field.data.designJson,
                            subject: field.data.subject,
                            from: field.data.from,
                            fromName: field.data.fromName,
                            to: field.data.to,
                            cc: field.data.cc,
                            bcc: field.data.bcc,
                            TemplateName: field.DocName,
                            CreatedBy: ls.getSessionValueByKey("UserId"),
                            Status: field.data.Status,
                            LastModifiedDate: new Date()
                        })
                        .then(function(doc) {
                            resolve({ status: 200, message: 'Email Template Updated.' });
                        })
                } else {
                    mailtplRef.collection(`${field.CollectionName}`).doc(`${field.DocName}`).set({
                            //html: (ls.getSessionValueByKey("Role") == 1) ? field.data.html : bodyHtml,
                            html: field.data.html,
                            htmlRaw: field.data.html,
                            designJson: field.data.designJson,
                            subject: field.data.subject,
                            from: field.data.from,
                            fromName: field.data.fromName,
                            to: field.data.to,
                            cc: field.data.cc,
                            bcc: field.data.bcc,
                            TemplateName: field.DocName,
                            CreatedBy: ls.getSessionValueByKey("UserId"),
                            Status: field.data.Status,
                            LastModifiedDate: new Date()
                        })
                        .then(function(doc) {
                            resolve({ status: 200, message: 'Email Template Added.' });
                        })
                }
            })
        })
    },

    addMailtpl(context, field) {
        return new Promise((resolve, reject) => {
            if(field.data.TemplateName){
                mailtplRef.collection(`${field.CollectionName}`).doc(`${field.DocName}`).set({
                    html: field.data.html,
                    htmlRaw: field.data.html ? field.data.html : "",
                    designJson: field.data.designJson ? field.data.designJson : "",
                    subject: field.data.subject,
                    from: field.data.from,
                    fromName: field.data.fromName,
                    TemplateName: field.data.TemplateName,
                    CreatedBy: ls.getSessionValueByKey("UserId"),
                    Status: field.data.Status,
                    LastModifiedDate: new Date()
                })
                .then(async function(doc) {
                    //await mailtplRef.collection(`${field.CollectionName}`).doc(doc.id).update({id: doc.id});
                    resolve({ status: 200, message: 'Data Added.' })
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
            }else{
                reject(error)
            }
        })
    },


    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })
        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },

    removeRecord({ commit }, mailtpleId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/mailtple-management/mailtples/${mailtpleId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', mailtpleId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    }
}